var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProjectSetupNewIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7856 2.50008C12.4687 2.50008 13.8332 3.86455 13.8332 5.5477V9.83341C13.8332 11.7003 13.8332 12.6337 13.4699 13.3467C13.1503 13.9739 12.6403 14.4839 12.0131 14.8034C11.3001 15.1667 10.3667 15.1667 8.49984 15.1667C6.633 15.1667 5.69958 15.1667 4.98654 14.8034C4.35933 14.4839 3.84939 13.9739 3.52982 13.3467C3.1665 12.6337 3.1665 11.7003 3.1665 9.83342V5.5477C3.1665 3.86455 4.53097 2.50008 6.21412 2.50008M6.49984 7.83342H10.4998M6.49984 10.5001H9.1665M7.16659 3.83341H9.83325C10.5696 3.83341 11.1666 3.23646 11.1666 2.50008C11.1666 1.7637 10.5696 1.16675 9.83325 1.16675H7.16659C6.43021 1.16675 5.83325 1.7637 5.83325 2.50008C5.83325 3.23646 6.43021 3.83341 7.16659 3.83341Z",
    stroke: "#4D6EF5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProjectSetupNewIcon);
export default ForwardRef;